import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgotPasswordReducer from "./auth/forgetpwd/reducer";
import AccountReducer from "./auth/register/reducer";
import HumanResourcesReducer from './human-resources/reducer'
import AdminUsersSlice from './admin/users/reducer'
import AdminRolesSlice from './admin/roles/reducer'
import AdminScreensSlice from './admin/screens/reducer'
import OpportunitiesSlice from './business-development/opportunities/reducer'
import OpportunityDashboardSlice from './business-development/opportunity-dashboard/reducer'
import EmployeesSlice from './human-resources/employees/reducer'
import HrDashboardSlice from './human-resources/hr-dashboard/reducer'
import HrReportsSlice from './human-resources/hr-reports/reducer'
import EmergencyContactsSlice from './human-resources/emergency-contacts/reducer'
import DocumentGeneratorSlice from './human-resources/document-generator/reducer'
import ProjectsSlice from './project-managment/projects/reducer'
import RocksSlice from './business-development/rocks/reducer'
import DashboardSlice from './dashboard/reducer'
import PermissionsSlice from './auth/permissions/reducer'
import BudgetActualSlice from './finance/budget-actuals/reducer'
import ProjectForecastSlice from "./project-managment/project-forecast/reducer";
import ProjectProfitability from "./project-managment/project-profitabilty/reducer";
import OpportunityForecastSlice from './business-development/opportunity-forecast/reducer';
import SubAccountBudgetsSlice from './finance/department-budget/reducer';
import SyncLogSlice from './sync-log/reducer'
import HelpDocumentsSlice from './help-documents/reducer'
import GrossMarginReportSlice from "./finance/gross-margin-report/reducer";
import ConsultingRevenueVsBudgetSlice from "./finance/consulting-revenue-budget/reducer";
import ConsultingIncomeSlice from "./finance/consulting-income/reducer";
import BillabilitySlice from "./finance/billability/reducer";
import ClientEngagementSlice from './business-development/client-engagement/reducer'
import IndustryEngagementSlice from './business-development/industry-engagement/reducer'
import ClientSlice from './business-development/client/reducer'
import AdminDepartmentLevelsSlice from './admin/department-levels/reducer'
import AdminBillabilityUtilizationTargetsSlice from './admin/billability-utilization-targets/reducer'
import AdminDepartmentsSlice from './admin/departments/reducer'
import AdminProjectHealthRulesSlice from './admin/project-health-rules/reducer'
import AdminProjectMarginTargetsSlice from './admin/project-margin-targets/reducer'
import AdminRegionMappingSlice from './admin/region-mapping/reducer'
import AdminClientMappingSlice from './admin/client-mapping/reducer'
import FinancialKpiSlice from './finance/financial-kpi/reducer'
import ProjectMarginTargetsSlice from './project-managment/margin-targets/reducer'
import AdminFiscalYearsSlice from './admin/fiscal-years/reducer'
import AdminLambdaTrackerSlice from './admin/lambda-tracker/reducer'
import AdminMemosSlice from './admin/memos/reducer'
import FiscalYearsSlice from './fiscal-years/reducer'
import ContinuingEducationSlice from './forms/continuing-education/reducer'
import ManualsSlice from './manuals/reducer'
import DemoDataSlice from './admin/demo-data/reducer'


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgotPasswordReducer,
    Account: AccountReducer,
    HumanResources: HumanResourcesReducer,
    AdminUser: AdminUsersSlice,
    AdminRoles: AdminRolesSlice,
    AdminScreens: AdminScreensSlice,
    Opportunities: OpportunitiesSlice,
    OpportunityDashboard: OpportunityDashboardSlice,
    Employees: EmployeesSlice,
    HrDashboard: HrDashboardSlice,
    HrReports: HrReportsSlice,
    EmergencyContacts: EmergencyContactsSlice,
    DocumentGenerator: DocumentGeneratorSlice,
    Projects: ProjectsSlice,
    ProjectForecast: ProjectForecastSlice,
    ProjectProfitability: ProjectProfitability,
    Rocks: RocksSlice,
    Dashboard: DashboardSlice,
    Permissions: PermissionsSlice,
    BudgetActual: BudgetActualSlice,
    OpportunityForecast: OpportunityForecastSlice,
    SubAccountBudgets: SubAccountBudgetsSlice,
    SyncLog: SyncLogSlice,
    HelpDocuments: HelpDocumentsSlice,
    GrossMarginReport: GrossMarginReportSlice,
    ConsultingRevenueVsBudget: ConsultingRevenueVsBudgetSlice,
    ConsultingIncome: ConsultingIncomeSlice,
    Billability: BillabilitySlice,
    ClientEngagement: ClientEngagementSlice,
    IndustryEngagement: IndustryEngagementSlice,
    Client: ClientSlice,
    AdminDepartmentLevels: AdminDepartmentLevelsSlice,
    AdminBillabilityUtilizationTargets: AdminBillabilityUtilizationTargetsSlice,
    AdminDepartments: AdminDepartmentsSlice,
    AdminProjectHealthRules: AdminProjectHealthRulesSlice,
    AdminProjectMarginTargets: AdminProjectMarginTargetsSlice,
    AdminRegionMapping: AdminRegionMappingSlice,
    AdminClientMapping: AdminClientMappingSlice,
    FinancialKpi: FinancialKpiSlice,
    ProjectMarginTargets: ProjectMarginTargetsSlice,
    AdminFiscalYears: AdminFiscalYearsSlice,
    AdminLambdaTracker: AdminLambdaTrackerSlice,
    AdminMemos: AdminMemosSlice,
    FiscalYears: FiscalYearsSlice,
    ContinuingEducation: ContinuingEducationSlice,
    Manuals: ManualsSlice,
    DemoData: DemoDataSlice
});

export default rootReducer;